import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";

const MaintenanceHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('الصيانة الوقائية');
    
  return (
    <div>
    </div>
  );
};

export default MaintenanceHomePage;
